<template>
    <div>
        <div class="loader" v-if="saving"></div>
        <div class="col-12 mx-auto row" v-if="!saving">
            <div class="row col-12 justify-content-around mb-3 ">
                <div class="col-lg-4 col-md-4 col-sm-12 mt-2">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="redirectToList"
                    >
                        <i class="fas fa-th-list"></i> {{ $t("backToList") }}
                    </button>
                </div>

                <div class="col-lg-8 col-md-8 col-sm-12">
                    <page-title :title="pageTitle" :icon="isNew ? 'far fa-plus-square' : 'far fa-edit'" :class="'p-2'" :sizeClass="'h3'"></page-title>
                </div>
            </div>

            <div class="form-group col-md-6">
                <label class="font-weight-bold required">Име на регистър</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="register.name"
                    v-validate="'required'"
                    :name="'registerName' + _uid"
                />
                <span
                    class="text-danger"
                    v-if="errors.has('registerName' + _uid)"
                    >{{ errors.first("registerName" + _uid) }}</span
                >
            </div>
            <div class="form-group col-md-6">
                <label class="font-weight-bold required"
                    >Име на регистър на английски</label
                >
                <input
                    type="text"
                    class="form-control"
                    v-model="register.nameEn"
                    v-validate="'required'"
                    :name="'registerNameEn' + _uid"
                />
                <span
                    class="text-danger"
                    v-if="errors.has('registerNameEn' + _uid)"
                    >{{ errors.first("registerNameEn" + _uid) }}</span
                >
            </div>

            <div class="col-12" v-if="!saving">
                <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="saving"
                    @click="onSubmit"
                >
                    <i class="fa fa-save"></i>
                    {{ $t("save") }}
                </button>
            </div>
        </div>
        <div v-if="!saving">
            <div class="row mt-5 mx-5">
                <div
                    class="col-md-8 dragArea pb-5"
                    @drop="droppedInRoot"
                    @dragover.prevent="dragOver"
                >
                    <draggable
                        v-model="register.panels"
                        @start="draggableDragStart"
                        @end="draggableDragEnd"
                        :options="{ animation: 150 }"
                    >
                        <transition-group
                            name="panelDragAnimation"
                            enter-active-class="animated lightSpeedIn"
                        >
                            <div
                                class="dropitem"
                                v-for="(panel, index) in register.panels"
                                :key="panel.sort"
                                @drop.prevent="droppedInPanel(index, $event)"
                            >
                                <panel
                                    :panel="panel"
                                    :components="panel.components"
                                    :isFormField="false"
                                    :isAuxRegisterField="isAuxiliary === true"
                                    :isEventFieldCode="isAuxiliary === false"
                                    draggable="true"
                                    @dragging="dragging = $event"
                                ></panel>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
                <div class="col-md-4">
                    <div class="card sticky-top" v-if="!dragging">
                        <div class="card-header bg-info text-white">
                            <div class="card-title h5 m-0">
                                Tools <i class="fas fa-tools float-right"></i>
                            </div>
                        </div>
                        <div class="card-body">
                            <div
                                v-for="c in draggableComponents"
                                :key="c.type"
                                :class="
                                    c.type === 'panel'
                                        ? 'panel pointer'
                                        : 'input pointer mt-2'
                                "
                                :data-type="c.type"
                                draggable="true"
                                @dragstart="onDragStart"
                            >
                                {{ c.title }}
                            </div>
                        </div>
                    </div>

                    <draggable
                        v-model="trashZone"
                        class="dropzone trashzone sticky-top"
                        :options="trashOptions"
                    >
                        <div class="card sticky-bottom" v-if="dragging">
                            <div class="card-header bg-danger text-white">
                                <div class="card-title h5 m-0">
                                    {{ $t("buttons.delete.btnText") }}
                                </div>
                            </div>
                            <div class="card-body text-center py-5">
                                <i
                                    class="fa fa-trash-alt fa-9x text-danger"
                                ></i>
                            </div>
                        </div>
                    </draggable>
                </div>

                <div class="text-center mt-3 col-12">
                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="saving"
                        @click="onSubmit"
                    >
                        <i class="fa fa-save"></i>
                        {{ $t("save") }}
                    </button>
                </div>

                <div v-if="validationErrors">
                    <br />
                    <br />
                    <h4 class="text-danger">
                        {{ validationErrors }}
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Panel from "../../components/editor/Panel";
import {
    EditorComponentModel,
    EditorPanel,
    EditorRegister,
} from "../../models/models";
import { ComponentSize } from "../../models/enums";
import Draggable from "vuedraggable";
import PageTitle from "../../components/common/PageTitle";
import actionLogService from '../../services/actionLog.service';

export default {
    props: {
        id: Number,
        isAuxiliary: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        panel: Panel,
        Draggable,
        PageTitle,
    },
    data() {
        return {
            saving: false,
            currentPanelSort: 1,
            currentComponentSort: 1,
            panelId: 1,
            register: new EditorRegister(),

            dragging: false,
            trashZone: [],
            trashOptions: {
                group: {
                    name: "trash",
                    draggable: ".dropitem",
                    put: () => true,
                    pull: false,
                },
            },
            validationErrors: "",
        };
    },
    mounted: function () {
        if (!this.isNew) {
            this.load();
        }
    },
    methods: {
        droppedInRoot(event) {
            const componentType = event.dataTransfer.getData("componentType");
            if (componentType === "panel") {
                this.register.panels.push(
                    new EditorPanel({
                        name: "Първоначално име",
                        nameEn: "Initial name",
                        label: "Първоначален етикет",
                        labelEn: "Initial label",
                        sort: this.currentPanelSort++, // TODO:
                        components: [],
                    })
                );
            }
        },
        onDragStart(event) {
            event.dataTransfer.dropEffect = "copy";
            const componentType = event.target.dataset["type"];
            event.dataTransfer.setData("componentType", componentType);
        },
        dragOver(event) {
            // console.log(event);
        },
        draggableDragStart() {
            this.drag = true;
            this.dragging = true;
        },
        draggableDragEnd() {
            this.drag = false;
            this.dragging = false;
        },
        droppedInPanel(index, event) {
            event.stopPropagation();
            const componentType = event.dataTransfer.getData("componentType");
            if (componentType !== "panel" && componentType !== "") {
                this.register.panels[index].components.push(
                    new EditorComponentModel({
                        fieldType: componentType,
                        name: "Първоначално име",
                        nameEn: "Initial name",
                        label: "Първоначален етикет", // this.$t('editor.panel.initialComponentLabel'),
                        labelEn: "Initial label",
                        sort: this.currentComponentSort++,
                        size: ComponentSize.Medium,
                    })
                );
            }
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.saving = true;
                    this.validationErrors = "";

                    this.setSort();

                    if (this.isNew) {
                        this.$http
                            .post(
                                `/api/${this.backendControllerName}`,
                                this.register
                            )
                            .then((response) => {
                                this.saving = false;
                                this.$vs.notify({
                                    title: this.pageTitle,
                                    text: this.$helpers.responseMessage(
                                        response
                                    ),
                                    color: "success",
                                    time: this.$store.getters
                                        .notificationDuration,
                                });

                                this.redirectToList();
                            })
                            .catch((error) => {
                                this.saving = false;

                                this.$vs.notify({
                                    title: this.pageTitle,
                                    text: this.$helpers.errorText(error),
                                    color: "danger",
                                    time: this.$store.getters
                                        .notificationDuration,
                                });

                                if (error.response.data.validationErrors) {
                                    this.validationErrors =
                                        error.response.data.validationErrors;
                                }
                            });
                    } else {
                        this.$http
                            .put(
                                `/api/${this.backendControllerName}/update`,
                                this.register
                            )
                            .then((response) => {
                                this.saving = false;
                                this.$vs.notify({
                                    title: this.pageTitle,
                                    text: this.$helpers.responseMessage(
                                        response
                                    ),
                                    color: "success",
                                    time: this.$store.getters
                                        .notificationDuration,
                                });

                                this.redirectToList();
                            })
                            .catch((error) => {
                                this.saving = false;

                                this.$vs.notify({
                                    title: this.pageTitle,
                                    text: this.$helpers.errorText(error),
                                    color: "danger",
                                    time: this.$store.getters
                                        .notificationDuration,
                                });

                                if (error.response.data.validationErrors) {
                                    this.validationErrors =
                                        error.response.data.validationErrors;
                                }
                            });
                    }
                }
            });
        },
        setSort() {
            let panelSort = 1;
            this.register.panels.forEach((panel) => {
                panel.sort = panelSort++;
                let componentSort = 0;
                panel.components.forEach((component) => {
                    component.sort = componentSort++;
                    component.fieldValue = null;
                });
            });
        },
        load() {
            this.$http
                .get(`/api/${this.backendControllerName}/${this.id}/structure`)
                .then((response) => {
                    this.register = new EditorRegister(response.data);
                    actionLogService.registerSchemaOpenForEdit(this.id, this.isAuxiliary);
                })
                .catch((error) => {
                    this.saving = false;

                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "danger",
                        time: this.$store.getters.notificationDuration,
                    });
                });
        },
        redirectToList() {
            this.isAuxiliary
                ? this.$router.push({ path: "/auxiliary/list" })
                : this.$router.push({ path: "/dynamic/list" });
        },
    },
    computed: {
        isNew() {
            return this.id === undefined;
        },
        backendControllerName() {
            return this.isAuxiliary ? "auxiliaryRegisters" : "dynamicRegisters";
        },
        pageTitle() {
            return `${
                this.isAuxiliary
                    ? this.$t("auxiliary.title")
                    : this.$t("registers.dynamic.title")
            }/${
                this.isNew
                    ? this.$t("buttons.create.btnText")
                    : this.$t("buttons.edit.btnText")
            }`;
        },
        draggableComponents() {
            return this.isAuxiliary
                ? [
                      { type: "panel", title: this.$t("editor.tools.panel") },
                      { type: "Input", title: this.$t("editor.tools.textbox") },
                      {
                          type: "Datepicker",
                          title: this.$t("editor.tools.datepicker"),
                      },
                      {
                          type: "Dropdown",
                          title: this.$t("editor.tools.dropdown"),
                      },
                      { type: "Toggle", title: this.$t("editor.tools.toggle") },
                      /* {
                          type: "PersonIdentification",
                          title: this.$t("editor.tools.personIdentification"),
                      }, */
                      /* {
                          type: "FileUpload",
                          title: this.$t("editor.tools.fileUpload"),
                      },
                      { type: "Person", title: this.$t("editor.tools.person") },
                      {
                          type: "Address",
                          title: this.$t("editor.tools.address"),
                      }, */
                      {
                          type: "StarRating",
                          title: this.$t("editor.tools.startRating"),
                      },
                  ]
                : [
                      { type: "panel", title: this.$t("editor.tools.panel") },
                      { type: "Input", title: this.$t("editor.tools.textbox") },
                      {
                          type: "Datepicker",
                          title: this.$t("editor.tools.datepicker"),
                      },
                      {
                          type: "Dropdown",
                          title: this.$t("editor.tools.dropdown"),
                      },
                      { type: "Toggle", title: this.$t("editor.tools.toggle") },
                      {
                          type: "PersonIdentification",
                          title: this.$t("editor.tools.personIdentification"),
                      },
                      {
                          type: "FileUpload",
                          title: this.$t("editor.tools.fileUpload"),
                      },
                      { type: "Person", title: this.$t("editor.tools.person") },
                      {
                          type: "PersonList",
                          title: this.$t("editor.tools.personList"),
                      },
                      {
                          type: "Address",
                          title: this.$t("editor.tools.address"),
                      },
                      {
                          type: "StarRating",
                          title: this.$t("editor.tools.startRating"),
                      },
                  ];
        },
    },
};
</script>

<style scoped>
.panel {
    border: 1px solid #3498db;
    border-radius: 3px;
    padding: 10px;
}

.input {
    border: 1px solid #009688;
    border-radius: 3px;
    padding: 10px;
}

.dragArea {
    background: #ccc;
    /*opacity: 0.5;*/
}

.pointer {
    cursor: pointer;
}

.trashzone .dropitem {
    display: none;
}
</style>
